import type { AlertSeverity } from '@/types/alert';
import type { RichtextStoryblok } from '@/types/component-types-sb';

export enum ErrorType {
  UNAUTHORIZED = 'UNAUTHORIZED',
  EMPTY = 'EMPTY',
  OVER = 'OVER',
  UPCOMING = 'UPCOMING',
  DEFAULT = 'DEFAULT',
}

export type ErrorEntity = {
  title: string | undefined;
  text: RichtextStoryblok | undefined;
  severity: AlertSeverity;
};

export type ErrorState = {
  title: string | undefined;
  text: RichtextStoryblok | undefined;
  severity?: AlertSeverity;
} | null;

export type RevealSuccess = {
  code: string;
};

export type RevealError = {
  error: ErrorType;
};

export type RevealType = RevealSuccess | RevealError;

export type SendStatus = {
  success: boolean;
  error?: ErrorType;
};

export interface Vorteil {
  id: string;
  userId: string;
  vtwItemId: string;
  date: string;
  userCode: string;
}
